import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

const Navbarconnexion = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'transparent',
                position: 'absolute',
                width: '100%',
                marginTop: '1rem',
            }}
        >
            <Box sx={{marginLeft: {md:'3rem',xs:'2rem'},}}>
                <Link to='/' sx={{color:'black', textDecoration: 'none' }}>
                    <img src={`./././logorocs.png`} alt="Logo" style={{width: '10vh', height: 'auto' }} />
                </Link>
            </Box>
        </Box>
    );
};

export default Navbarconnexion;
